import styled from "styled-components";

export const LicenseFieldGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 18px;

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
    }
`;

export const LicenseField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 9px;
`;

export const LicenseFieldLabel = styled.div`
    color: #000;
    font-size: 14px;
    font-weight: 700;
`;

export const LicenseReadonlyInput = styled.div`
    min-height: 39px;
    padding: 11px 18px;
    box-sizing: border-box;
    border: 1px solid #9DAED0;
    border-radius: 7px;
    box-shadow: 0px 3px 6px #00000029;
    color: #000;
    font-size: 14px;
    line-height: 17px;
`;

export const CurrentTierBadge = styled.div`
    justify-self: end;
    min-width: 123px;
    height: 32px;
    padding: 0 18px;
    box-sizing: border-box;
    border-radius: 7px;
    background: #633FE4;
    box-shadow: 0px 3px 6px #00000029;
    color: #FFF;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
`;

export const UserDetailsHeader = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 16px;
    margin-bottom: 22px;
`;

export const TierCard = styled.div`
    min-height: 80px;
    padding: 16px 22px;
    margin-top: 14px;
    box-sizing: border-box;
    border: 1px solid #9DAED0;
    border-radius: 15px;
    box-shadow: 0px 5px 10px #0000001A;
    background: ${p => p.current ? "rgba(91,110,245,0.12)" : "#FFF"};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
`;

export const TierName = styled.div`
    color: #000;
    font-size: 15px;
    font-weight: 700;
`;

export const CurrentText = styled.span`
    text-align: left;
    font: normal normal bold 15px/18px Manrope;
    letter-spacing: 0px;
    color: #76C00E;
`;

export const TierPrice = styled.div`
    margin-top: 5px;
    color: #000;
    font-size: 12px;
    font-weight: 700;
`;

export const ChangeLicenseButton = styled.button`
    width: 115px;
    height: 32px;
    border: none;
    border-radius: 7px;
    background: #171A22;
    box-shadow: 0px 3px 6px #00000029;
    color: #FFFFFF;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
`;

export const ModalSecondaryButton = styled.button`
    width: 140px;
    height: 38px;
    border: 1px solid #000;
    border-radius: 7px;
    background: #FFF;
    box-shadow: 0px 3px 6px #00000029;
    color: #000;
    font: normal normal medium 14px/16px Manrope;
    cursor: pointer;
`;

export const ModalPrimaryButton = styled.button`
    width: 140px;
    height: 38px;
    border: none;
    border-radius: 7px;
    background: #171A22;
    box-shadow: 0px 3px 6px #00000029;
    color: #FFF;
    font: normal normal medium 14px/16px Manrope;
    cursor: pointer;
    opacity: ${p => p.disabled ? 0.7 : 1};
`;

export const ChangeOverview = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) 72px minmax(0, 1fr);
    align-items: center;
    gap: 28px;
    margin-top: 22px;

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
    }
`;

export const LicenseNote = styled.p`
    margin: 34px 0 0;
    color: #8551AE;
    font-size: 14px;
    line-height: 17px;
`;

export const ArrowWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;
